import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListarApiKeysComponent } from './listar-apikeys/listar-apikeys.component';

const routes: Routes = [{ path: '', component: ListarApiKeysComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ApiKeysRoutingModule {}
